import React from "react";

const cardBack = "https://varia-db.vercel.app/assets/images/Varia%20Back.jpg";

const CustomDeck = (cardExcel, deckList) => {
  // Array of card IDs
  const cardIDs = deckList.map((item, index) => {
    const name = item.Card_Name;
    return { id: 100 + index * 101, name };
  });

  // Array of nicknames
  const nicknames = deckList.map((card) => card.Card_Name);

  // Create an array to hold the card objects
  const cards = deckList.map((card, index) => ({
    CardID: cardIDs
      .filter((item) => item.name === card.Card_Name)
      .map((item) => item.id)[0],
    Name: "Card",
    Nickname: nicknames[index].toString().replaceAll("'", ""),
    Transform: {
      posX: 0,
      posY: 0,
      posZ: 0,
      rotX: 0,
      rotY: 180,
      rotZ: 180,
      scaleX: 2.5,
      scaleY: 1,
      scaleZ: 2.5,
    },
  }));

  // Define the deck data with the dynamic CustomDeck property
  const deckData = {
    ObjectStates: [
      {
        Name: "DeckCustom",
        ContainedObjects: cards,
        DeckIDs: cardIDs.map((card) => card.id),
        CustomDeck: deckList.reduce((result, card, index) => {
          result[index + 1] = {
            FaceURL:
              "https://varia-db.vercel.app/assets/images/" +
              card.fileloc.toString().replaceAll(" ", "%20"),
            BackURL:
              "https://varia-db.vercel.app/assets/images/" +
                card.JSN.toString().replaceAll(" ", "%20") || cardBack,
            NumHeight: 1,
            NumWidth: 1,
            BackIsHidden: true,
          };
          return result;
        }, {}),
        Transform: {
          posX: 0,
          posY: 1,
          posZ: 0,
          rotX: 0,
          rotY: 180,
          rotZ: 180,
          scaleX: 2.5,
          scaleY: 1,
          scaleZ: 2.5,
        },
      },
    ],
  };

  return deckData;
};

export default CustomDeck;
